import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import Toasted  from 'vue-toasted';
import Vuex from 'vuex';
import { LMap, LTileLayer, LMarker, LPolyline } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import Home from './views/Home';
import ThingDescriptions from './views/ThingDescriptions';
import News from './views/News';
import Scenarios from './views/Scenarios';
import About from './views/About';
import NotFound from './views/NotFound';
import KNXSuitcase from './views/scenarios/KNXSuitcase';
import iiotGarbage from './views/scenarios/iiot/iiotGarbage';
import Truck from './views/scenarios/iiot/Trucks';
import TruckDetailView from './views/scenarios/iiot/TruckDetailView';
import TruckDetailViewMeh from './views/scenarios/iiot/TruckDetailViewMeh';
import Grafana from './views/scenarios/Grafana';
import Container from './views/scenarios/iiot/Containers';
import ContainerDetailView from './views/scenarios/iiot/ContainerDetailView';
import ContainerMapView from './views/scenarios/iiot/ContainerMapView';
import './scss/main.scss';
import NewsDetails from './views/news/NewsDetails';
import NewsSection from './components/home/NewsSection';
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Toasted);
Vue.use(vuetify);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polyline', LPolyline);
Vue.config.productionTip = false

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
   iconUrl: require('leaflet/dist/images/marker-icon.png'),
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    { path: '/thing-descriptions', component: ThingDescriptions },
    { path: '/news', component: News	},
    { path: '/scenarios', component: Scenarios },
    { path: '/scenarios/knxsuitcase', component: KNXSuitcase },
    { path: '/scenarios/labsensors', component: Grafana },
    { path: '/scenarios/containers', component: Container },
    { path: '/scenarios/containers/map', component: ContainerMapView },
    { path: '/scenarios/containers/:serialNumber', component: ContainerDetailView },
    { path: '/news/:id', name: 'news-details', component: NewsDetails }, 
    { path: '/about', component: About },
    { path: '*', component: NotFound },
    { path: '/news', component: NewsSection	},
    { path: '/news/:id',name: 'news-section' ,component: NewsDetails }
    
  ],
  mode: 'history'
})

const store = new Vuex.Store({
  state: {
    containerDetail: {},
  },
  mutations: {
    setContainerDetail(state, cont) {
      state.containerDetail = cont;
    }
  },
  getters: {
    getContainer: state => {
      return state.containerDetail;
    }
  }
})

new Vue({
  router,
  vuetify,
  el: '#app',
  store: store,
  render: h => h(App)
}).$mount('#app')